import axios from "axios";
import authManager from "./authManager";

const instance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  withCredentials: true,
});
instance.interceptors.request.use((config) => {
  config.params = config.params || {};
  return config;
});
// instance.interceptors.request.use(async (config) => {
// config.params = config.params || {};

// const method = config.method?.toLowerCase();
// const needsCsrf = ["post", "put", "patch", "delete"].includes(method || "");

// if (needsCsrf) {
// const res = await instance.get("/api/csrf-token");
// config.headers["X-CSRF-Token"] = res.data.csrfToken;
// }

// return config;
// });
const ApiInterceptor = () => {
  instance.interceptors.response.use(
    function (response) {
      return response;
    },
    function (error) {
      if (error.response?.status === 401) {
        if (error.config) {
          window.location.href = "/";
        }
      }
      return Promise.reject(error);
    }
  );
  return null;
};
ApiInterceptor();
const apiRequest = {
  login: ({ v = "v1", body = {} } = {}) =>
    instance.post(`/api/admin/${v}/login`, body),

  sendOtp: ({ v = "v1", body = {} } = {}) =>
    instance.post(`/api/admin/${v}/sendOtp`, body),
  resetPassword: ({ v = "v1", body = {} } = {}) =>
    instance.post(`/api/admin/${v}/resetPassword`, body),

  getDashboardData: ({ v = "v1" } = {}) =>
    instance.get(`/api/admin/${v}/getDashboardData`, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),
  getProfile: ({ v = "v1" } = {}) =>
    instance.get(`/api/admin/${v}/profile`, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),

  getServerInfo: ({ v = "v1" } = {}) =>
    instance.get(`/api/admin/${v}/serverInfo`, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),
  updateProfile: ({ v = "v1", body = {} } = {}) =>
    instance.post(`/api/admin/${v}/updateProfile`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),

  getMainCategory: ({ v = "v1", body } = {}) =>
    instance.post(`/api/admin/${v}/main-category`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),

  createMainCategory: ({ v = "v1", body = {} } = {}) =>
    instance.post(`/api/admin/${v}/main-category/create`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),

  updateMainCategory: ({ v = "v1", id = "", body = {} } = {}) =>
    instance.put(`/api/admin/${v}/main-category/${id}`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),

  deleteMainCategory: ({ v = "v1", id = "" } = {}) =>
    instance.delete(`/api/admin/${v}/main-category/${id}`, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
        "Content-Type": "multipart/form-data",
      },
    }),

  getCategory: ({ v = "v1", body } = {}) =>
    instance.post(`/api/admin/${v}/category`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),

  createCategory: ({ v = "v1", formData = {} } = {}) => {
    console.log("FormData being sent:", formData);
    return instance.post(`/api/admin/${v}/category/create`, formData, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
        "Content-Type": "multipart/form-data",
      },
    });
  },

  updateCategory: ({ v = "v1", id = "", formData = {} } = {}) =>
    instance.put(`/api/admin/${v}/category/${id}`, formData, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
        "Content-Type": "multipart/form-data",
      },
    }),

  updateProductStatus: ({ v = "v1", id = "", body = {} } = {}) =>
    instance.put(`/api/admin/${v}/product/status-update/${id}`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),

  deleteCategory: ({ v = "v1", id = "" } = {}) =>
    instance.delete(`/api/admin/${v}/category/${id}`, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),

  getAdminProducts: ({ v = "v1", body } = {}) =>
    instance.post(`/api/admin/${v}/product/getProducts`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),

  importProducts: ({ v = "v1", formData = {} } = {}) => {
    console.log("FormData being sent:", formData);
    return instance.post(`/api/admin/${v}/product/product-import`, formData, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
        "Content-Type": "multipart/form-data",
      },
    });
  },

  getImportProductsByExcel: ({ v = "v1", id = null, body } = {}) =>
    instance.post(
      `/api/admin/${v}/product/getImportProductsByExcel/${id}`,
      body,
      {
        headers: {
          Authorization: `Bearer ${authManager.getAccessToken()}`,
        },
      }
    ),

  updateSetting: ({ v = "v1", data = {} } = {}) =>
    instance.put(`/api/admin/${v}/siteSetting`, data, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),

  uploadLogo: ({ v = "v1", formData = {} } = {}) =>
    instance.post(`/api/admin/${v}/siteSetting/upload/logo`, formData, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
        "Content-Type": "multipart/form-data",
      },
    }),
  uploadFavicon: ({ v = "v1", formData = {} } = {}) =>
    instance.post(`/api/admin/${v}/siteSetting/upload/favicon`, formData, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
        "Content-Type": "multipart/form-data",
      },
    }),

  getCoupon: ({ v = "v1", body } = {}) =>
    instance.post(`/api/admin/${v}/coupon`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),

  createCoupon: ({ v = "v1", body = {} } = {}) =>
    instance.post(`/api/admin/${v}/coupon/create`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),
  editCoupon: ({ v = "v1", id = "", body = {} } = {}) =>
    instance.put(`/api/admin/${v}/coupon/${id}`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),

  deleteCoupon: ({ v = "v1", id = "" } = {}) =>
    instance.delete(`/api/admin/${v}/coupon/${id}`, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),

  //
  getCorporateCode: ({ v = "v1", body } = {}) =>
    instance.post(`/api/admin/${v}/corporate-code`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),
  getCorporateCodeIdCode: ({ v = "v1", body } = {}) =>
    instance.post(`/api/admin/${v}/corporate-code/corporate-code-data`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),
  getVendorByCorporateCodeId: ({ v = "v1", body } = {}) =>
    instance.post(
      `/api/admin/${v}/vendor/vendor-manager-by-corporate-code`,
      body,
      {
        headers: {
          Authorization: `Bearer ${authManager.getAccessToken()}`,
        },
      }
    ),

  createCorporateCode: ({ v = "v1", body = {} } = {}) =>
    instance.post(`/api/admin/${v}/corporate-code/create`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),
  editCorporateCode: ({ v = "v1", id = "", body = {} } = {}) =>
    instance.put(`/api/admin/${v}/corporate-code/${id}`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),

  deleteCorporateCode: ({ v = "v1", id = "" } = {}) =>
    instance.delete(`/api/admin/${v}/corporate-code/${id}`, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),

  //

  editProductImage: ({ v = "v1", id = "", formData = {} } = {}) =>
    instance.put(`/api/admin/${v}/product/productImage/${id}`, formData, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),

  // address

  getCountry: ({ v = "v1", body } = {}) =>
    instance.post(`/api/admin/${v}/country`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),
  createCountry: ({ v = "v1", body = {} } = {}) =>
    instance.post(`/api/admin/${v}/country/create`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),
  editCountry: ({ v = "v1", id = "", body = {} } = {}) =>
    instance.put(`/api/admin/${v}/country/${id}`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),
  deleteCountry: ({ v = "v1", id = "" } = {}) =>
    instance.delete(`/api/admin/${v}/country/${id}`, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),

  getState: ({ v = "v1", body } = {}) =>
    instance.post(`/api/admin/${v}/state`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),

  getStateByCountryId: ({ v = "v1", body } = {}) =>
    instance.post(`/api/admin/${v}/state/by-country`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),

  createState: ({ v = "v1", body = {} } = {}) =>
    instance.post(`/api/admin/${v}/state/create`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),
  editState: ({ v = "v1", id = "", body = {} } = {}) =>
    instance.put(`/api/admin/${v}/state/${id}`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),
  deleteState: ({ v = "v1", id = "" } = {}) =>
    instance.delete(`/api/admin/${v}/state/${id}`, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),

  getCity: ({ v = "v1", body } = {}) =>
    instance.post(`/api/admin/${v}/city`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),
  getCityByState: ({ v = "v1", body } = {}) =>
    instance.post(`/api/admin/${v}/city/by-state`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),

  createCity: ({ v = "v1", body = {} } = {}) =>
    instance.post(`/api/admin/${v}/city/create`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),
  editCity: ({ v = "v1", id = "", body = {} } = {}) =>
    instance.put(`/api/admin/${v}/city/${id}`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),
  deleteCity: ({ v = "v1", id = "" } = {}) =>
    instance.delete(`/api/admin/${v}/city/${id}`, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),

  // vendor

  getVendor: ({ v = "v1", body } = {}) =>
    instance.post(`/api/admin/${v}/vendor`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),

  getVendorManager: ({ v = "v1", body } = {}) =>
    instance.post(`/api/admin/${v}/vendor/vendor-manager`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),

  getVendorManagerForSelect: ({ v = "v1", body } = {}) =>
    instance.post(`/api/admin/${v}/vendor/vendor-manager-list`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),

  getHeadVendors: ({ v = "v1", body } = {}) =>
    instance.post(`/api/admin/${v}/vendor/getHeadVendors`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),
  getVendorWithAdmin: ({ v = "v1", body } = {}) =>
    instance.post(`/api/admin/${v}/vendor/getVendorWithAdmin`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),
  getVendorById: ({ v = "v1", id = "", body } = {}) =>
    instance.post(`/api/admin/${v}/vendor/getStaffVendors`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),
  createVendor: ({ v = "v1", body = {} } = {}) =>
    instance.post(`/api/admin/${v}/vendor/create`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
        "Content-Type": "multipart/form-data",
      },
    }),

  editVendor: ({ v = "v1", id = "", body = {} } = {}) =>
    instance.put(`/api/admin/${v}/vendor/${id}`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
        "Content-Type": "multipart/form-data",
      },
    }),
  deleteVendor: ({ v = "v1", id = "" } = {}) =>
    instance.delete(`/api/admin/${v}/vendor/${id}`, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),

  // Admin
  getAdmin: ({ v = "v1", body } = {}) => {
    return instance.post(`/api/admin/${v}/getAdmins`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    });
  },
  // Admin
  getHeadAdmin: ({ v = "v1", body } = {}) => {
    return instance.post(`/api/admin/${v}/getHeadAdmins`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    });
  },

  createAdmin: ({ v = "v1", body = {} } = {}) =>
    instance.post(`/api/admin/${v}/create`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),

  editAdmin: ({ v = "v1", id = "", body = {} } = {}) =>
    instance.put(`/api/admin/${v}/admin/${id}`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),
  deleteAdmin: ({ v = "v1", id = "" } = {}) =>
    instance.delete(`/api/admin/${v}/${id}`, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),

  // excel
  assignToVendor: ({ v = "v1", body = {} } = {}) =>
    instance.post(`/api/admin/${v}/excel/assignToVendor`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),

  getExcelImportList: ({ v = "v1", body } = {}) => {
    return instance.post(`/api/admin/${v}/excel/imports`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    });
  },

  deleteExcel: ({ v = "v1", id = "" } = {}) =>
    instance.delete(`/api/admin/${v}/excel/${id}`, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),

  // corporate code
  getCorporateAdmin: ({ v = "v1", body } = {}) => {
    return instance.post(`/api/admin/${v}/corporate-admin/get`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    });
  },

  getCorporateCodeByVendorId: ({ v = "v1", body } = {}) => {
    return instance.post(
      `/api/admin/${v}/vendor/vendor-by-corporate-code`,
      body,
      {
        headers: {
          Authorization: `Bearer ${authManager.getAccessToken()}`,
        },
      }
    );
  },

  getCorporateAdminByHeadAdmin: ({ v = "v1", body } = {}) => {
    return instance.post(`/api/admin/${v}/corporate-admin/get-by-admin`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    });
  },

  getSuperVendorsByCorporateAdmin: ({ v = "v1", body } = {}) => {
    return instance.post(
      `/api/admin/${v}/vendor/get-super-vendor-by-corporate-admin`,
      body,
      {
        headers: {
          Authorization: `Bearer ${authManager.getAccessToken()}`,
        },
      }
    );
  },
  getCorporateCodesBySuperVendor: ({ v = "v1", body } = {}) => {
    return instance.post(
      `/api/admin/${v}/vendor/get-corporate-code-by-super-vendor`,
      body,
      {
        headers: {
          Authorization: `Bearer ${authManager.getAccessToken()}`,
        },
      }
    );
  },

  getCorporateCodesByCorporateAdmin: ({ v = "v1", body } = {}) => {
    return instance.post(
      `/api/admin/${v}/corporate-admin/get-corporate-code-by-corporate-admin`,
      body,
      {
        headers: {
          Authorization: `Bearer ${authManager.getAccessToken()}`,
        },
      }
    );
  },

  createCorporateAdmin: ({ v = "v1", body = {} } = {}) =>
    instance.post(`/api/admin/${v}/corporate-admin/create`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),

  editCorporateAdmin: ({ v = "v1", id = "", body = {} } = {}) =>
    instance.put(`/api/admin/${v}/corporate-admin/${id}`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),

  deleteCorporateAdmin: ({ v = "v1", id = "" } = {}) =>
    instance.delete(`/api/admin/${v}/corporate-admin/${id}`, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),

  getOrderedProductWithAttributeDetail: ({ v = "v1", id } = {}) =>
    instance.get(`/api/user/${v}/getOrderedProductWithAttributeDetail/${id}`, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),

  uploadOpenGraphImage: ({ v = "v1", formData = {} } = {}) =>
    instance.post(
      `/api/admin/${v}/siteSetting/upload/openGraphImage`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${authManager.getAccessToken()}`,
          "Content-Type": "multipart/form-data",
        },
      }
    ),
  uploadHomepageBanner: ({ v = "v1", formData = {} } = {}) =>
    instance.post(
      `/api/admin/${v}/siteSetting/upload/homePageBanner`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${authManager.getAccessToken()}`,
          "Content-Type": "multipart/form-data",
        },
      }
    ),
  deleteHomePageBanner: ({ v = "v1", imageId } = {}) =>
    instance.delete(
      `/api/admin/${v}/siteSetting/homePageBanner/${imageId}`,

      {
        headers: {
          Authorization: `Bearer ${authManager.getAccessToken()}`,
        },
      }
    ),
  updateHomePageBanner: ({ v = "v1", imageId, formData } = {}) =>
    instance.put(
      `/api/admin/${v}/siteSetting/homePageBanner/${imageId}`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${authManager.getAccessToken()}`,
          "Content-Type": "multipart/form-data",
        },
      }
    ),
  getUsers: ({ v = "v1", body } = {}) =>
    instance.post(`/api/admin/${v}/getUsers`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),
  createUser: ({ v = "v1", body } = {}) =>
    instance.post(`/api/admin/${v}/createUser`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),

  getBrand: ({ v = "v1", body } = {}) =>
    instance.post(`/api/admin/${v}/get-brand`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),
  createBrand: ({ v = "v1", formData = {} } = {}) =>
    instance.post(`/api/admin/${v}/brand`, formData, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),
  editBrand: ({ v = "v1", id = "", formData = {} } = {}) =>
    instance.patch(`/api/admin/${v}/brand/${id}`, formData, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),
  deleteBrand: ({ v = "v1", id = "" } = {}) =>
    instance.delete(`/api/admin/${v}/brand/${id}`, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),
  getModel: ({ v = "v1", body } = {}) =>
    instance.post(`/api/admin/${v}/get-model`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),
  createModel: ({ v = "v1", body = {} } = {}) =>
    instance.post(`/api/admin/${v}/model`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),
  editModel: ({ v = "v1", id = "", body = {} } = {}) =>
    instance.patch(`/api/admin/${v}/model/${id}`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),
  deleteModel: ({ v = "v1", id = "" } = {}) =>
    instance.delete(`/api/admin/${v}/model/${id}`, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),
  getSeries: ({ v = "v1", body } = {}) =>
    instance.post(`/api/admin/${v}/get-series`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),
  createSeries: ({ v = "v1", body = {} } = {}) =>
    instance.post(`/api/admin/${v}/series`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),
  editSeries: ({ v = "v1", id = "", body = {} } = {}) =>
    instance.patch(`/api/admin/${v}/series/${id}`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),
  deleteSeries: ({ v = "v1", id = "" } = {}) =>
    instance.delete(`/api/admin/${v}/series/${id}`, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),

  getAttribute: ({ v = "v1", body } = {}) =>
    instance.post(`/api/admin/${v}/get-attribute`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),
  createAttribute: ({ v = "v1", body = {} } = {}) =>
    instance.post(`/api/admin/${v}/attribute`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),
  editAttribute: ({ v = "v1", id = "", body = {} } = {}) =>
    instance.patch(`/api/admin/${v}/attribute/${id}`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),
  deleteAttribute: ({ v = "v1", id = "" } = {}) =>
    instance.delete(`/api/admin/${v}/attribute/${id}`, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),
  getAttributeQuestion: ({ v = "v1", body } = {}) =>
    instance.post(`/api/admin/${v}/getAttributeQuestion`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),
  createAttributeQuestion: ({ v = "v1", body = {} } = {}) =>
    instance.post(`/api/admin/${v}/attributeQuestion`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),
  editAttributeQuestion: ({ v = "v1", id = "", body = {} } = {}) =>
    instance.patch(`/api/admin/${v}/attributeQuestion/${id}`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),
  deleteAttributeQuestion: ({ v = "v1", id = "" } = {}) =>
    instance.delete(`/api/admin/${v}/attributeQuestion/${id}`, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),

  getProduct: ({ v = "v1", body } = {}) =>
    instance.post(`/api/admin/${v}/getProduct`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),
  createProduct: ({ v = "v1", body = {} } = {}) =>
    instance.post(`/api/admin/${v}/product`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),
  editProduct: ({ v = "v1", id = "", body = {} } = {}) =>
    instance.patch(`/api/admin/${v}/product/${id}`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),
  deleteProduct: ({ v = "v1", id = "" } = {}) =>
    instance.delete(`/api/admin/${v}/product/${id}`, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),
  uploadProductImage: ({ v = "v1", formData = {} } = {}) =>
    instance.post(`/api/admin/${v}/productImage/uploadImage`, formData, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
        "Content-Type": "multipart/form-data",
      },
    }),

  deleteProductImage: ({ v = "v1", imagePath, productId } = {}) =>
    instance.delete(`/api/admin/${v}/productImage/deleteImage`, {
      data: { productId, imagePath },
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),
  setMainImage: ({ v = "v1", imagePath, productId } = {}) =>
    instance.patch(
      `/api/admin/${v}/productImage/setMainImage`,
      { productId, imagePath },
      {
        headers: {
          Authorization: `Bearer ${authManager.getAccessToken()}`,
        },
      }
    ),
  getOrders: ({ v = "v1", body } = {}) =>
    instance.post(`/api/admin/${v}/getOrders`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),
  updateOrder: ({ v = "v1", id = "", body } = {}) =>
    instance.put(`/api/admin/${v}/updateOrder/${id}`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),
  updateUser: ({ v = "v1", id = "", body } = {}) =>
    instance.put(`/api/admin/${v}/updateUser/${id}`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),
  updateCommission: ({ v = "v1", id = "", body } = {}) =>
    instance.patch(`/api/admin/${v}/commission/${id}`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),
  getCommission: ({ v = "v1", body } = {}) =>
    instance.post(`/api/admin/${v}/get-commission`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),
  createCommission: ({ v = "v1", body } = {}) =>
    instance.post(`/api/admin/${v}/commission`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),
  deleteCommission: ({ v = "v1", id = "" } = {}) =>
    instance.delete(`/api/admin/${v}/commission/${id}`, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),

  getLedger: ({ v = "v1", body } = {}) =>
    instance.post(`/api/admin/${v}/get-ledger`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),
  getCollection: ({ v = "v1", body } = {}) =>
    instance.post(`/api/admin/${v}/get-collection`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),

  createCollection: ({ v = "v1", body } = {}) =>
    instance.post(`/api/admin/${v}/collection`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),

  createCollection: ({ v = "v1", body } = {}) =>
    instance.post(`/api/admin/${v}/collection`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),

  // deleteCollection: ({ v = "v1", id = "" } = {}) =>
  // instance.delete(`/api/admin/${v}/collection/${id}`, {
  // headers: {
  // Authorization: `Bearer ${authManager.getAccessToken()}`,
  // },
  // }),

  updateCollection: ({ v = "v1", id = "", body } = {}) =>
    instance.patch(`/api/admin/${v}/collection/${id}`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),
  getOtp: ({ v = "v1", body } = {}) =>
    instance.post(`/api/admin/${v}/otps`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),

  getOrderById: ({ v = "v1", id = "", body } = {}) =>
    instance.post(`/api/admin/${v}/order-invoice/${id}`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),

  // payment gatway
  getVendorManagerPaymentGateway: ({ v = "v1", body } = {}) =>
    instance.post(`/api/admin/${v}/vendor-manager-gateway`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),

  createVendorManagerPaymentGateway: ({ v = "v1", body = {} } = {}) =>
    instance.post(`/api/admin/${v}/vendor-manager-gateway/create`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),
  editVendorManagerPaymentGateway: ({ v = "v1", id = "", body = {} } = {}) =>
    instance.put(`/api/admin/${v}/vendor-manager-gateway/${id}`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),

  deleteVendorManagerPaymentGateway: ({ v = "v1", id = "" } = {}) =>
    instance.delete(`/api/admin/${v}/vendor-manager-gateway/${id}`, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),

  getCorporateCodeForSelect: ({ v = "v1", body } = {}) =>
    instance.post(`/api/admin/${v}/corporate-code/corporate-code-list`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),
};

export default apiRequest;
